import DocImg from "../../../../src/components/docs/doc-img";
import stepCloud from "../../../../src/assets/docs/find-google-cloud-storage-url/find-google-cloud-storage-url-for-linkfive.png";
import * as React from 'react';
export default {
  DocImg,
  stepCloud,
  React
};